exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-sticky--fixed{position:fixed;top:0;right:0;left:0;z-index:99}", "", {"version":3,"sources":["/Users/hangz/Work/projects/vision-h5/node_modules/vant/es/sticky/index.css"],"names":[],"mappings":"AAAA,mBAAmB,eAAe,MAAM,QAAQ,OAAO,UAAU,CAAC","file":"index.css","sourcesContent":[".van-sticky--fixed{position:fixed;top:0;right:0;left:0;z-index:99}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--8-1!./node_modules/vant/es/sticky/index.css
// module id = zJVX
// module chunks = 212